import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { TranslationsByIdByNamespace } from '@spa/lib/i18n/common/TranslationsByIdByNamespace';
import formatMessage from '@spa/lib/i18n/common/formatMessage';
import logger from '@spa/lib/logger';

const createNamespacedIntl = (
  namespace: string,
  translationsByIdByNamespace: TranslationsByIdByNamespace,
  enableWarnings?: boolean
): NamespacedIntl => {
  const finalEnableWarnings = enableWarnings === undefined || enableWarnings;
  let translationsById = translationsByIdByNamespace[namespace];
  if (translationsById === undefined) {
    if (finalEnableWarnings) {
      logger.warn(`Translations for namespace not loaded [Namespace: ${namespace}]`);
    }
    translationsById = {};
  }

  return {
    formatMessage: (id, values, fallbackValue, fallbackIds): string => {
      return formatMessage(
        finalEnableWarnings,
        translationsById,
        id,
        namespace,
        values,
        fallbackValue,
        fallbackIds
      );
    },
    keyExists: (id): boolean => {
      return id in translationsById;
    }
  };
};

export default createNamespacedIntl;
